export const config = {
    api: {
        host: process.env.REACT_APP_API_HOST ?? 'http://localhost:4200'
    },
    cloudinary: {
        cloudName: 'dzsptpetn',
        uploadUrl: `https://api.cloudinary.com/v1_1/dzsptpetn/image/upload`
    }
};
